import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { useAuthStore } from '@presentation/stores/authStore';
import { QUERY_KEYS } from '@shared/constants';
import type {
  ChangePasswordPayload,
  UpdateProfilePayload,
} from '@core/repositories/ProfileRepository';

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (payload: UpdateProfilePayload) => container.profile.update(payload),
    onSuccess: (user) => {
      setUser(user);
      queryClient.setQueryData(QUERY_KEYS.currentUser, user);
    },
  });
};

export const useChangePassword = () => {
  return useMutation({
    mutationFn: (payload: ChangePasswordPayload) => container.profile.changePassword(payload),
  });
};

export const useUploadAvatar = () => {
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (file: File) => container.profile.uploadAvatar(file),
    onSuccess: (user) => {
      setUser(user);
      queryClient.setQueryData(QUERY_KEYS.currentUser, user);
    },
  });
};

export const useDeleteAvatar = () => {
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: () => container.profile.deleteAvatar(),
    onSuccess: (user) => {
      setUser(user);
      queryClient.setQueryData(QUERY_KEYS.currentUser, user);
    },
  });
};
